import React from "react";
import ReactDOM from "react-dom";
import App from './App';
import { createBrowserHistory } from "history";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from 'react-redux';
import configureStore, { getPersist } from 'core/redux-store/Store';
import { PersistGate } from 'redux-persist/integration/react';

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss";
import "assets/demo/demo.css";
import Loader from 'views/pages/Loader';

export const history = createBrowserHistory();
const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={<Loader/>}persistor={getPersist()}>
      <Router history={history}>
        <App />
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
